<div class="border-0 px-4 py-1 scroll-container" ref="manage_questions">
  <NavigationBackButton/>
  <div class="card-header card-header-primary shadow rounded-lg mt-2">
    <div class="nav-tabs-navigation">
      <div class="nav-tabs-wrapper">
        <ul class="nav nav-tabs" data-tabs="tabs">
          <li class="rounded-lg me-2 nav-item">
            <a class="text-white text-decoration-none fs-5 fw-bold nav-link" href="#profile" data-toggle="tab">
              <span><i class="bi bi-gear fs-4 me-2"></i></span>Status Management
            </a>
          </li>
        </ul>
        <div class="d-flex flex-row justify-content-end">
          <button class="btn btn-primary-dark btn-sm text-xxs shadow ms-3 mb-1" data-bs-toggle="modal" data-bs-target="#create_form_status"> Create Status</button>
        </div>
      </div>
    </div>
  </div>
  
  <div class="glassy-table rounded-lg border-0 p-3 shadow mt-2">
    <div class="card-body">
      <!-- Normal HTML Table -->
      <div class="table-responsive text-xs">
        <table id="status_table" class="table table-hover">
          <thead class="custom-header">
            <tr>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">ID</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Status</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Color</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="status in status_created" :key="status.id">
              <td class="text-xxs text-start">{{ status.id }}</td>
              <td class="text-xxs text-start">{{ status.form_status_name }}</td>
              <td class="text-xxs text-start">
                <div class="d-flex align-items-center">
                  <input
                    type="color"
                    :value="status.color"
                    @change="update_form_status(status.id, $event.target.value)"
                    class="form-control form-control-color p-1 me-2 w-25 h-25"
                    title="Choose color"
                  />
                  <span class="text-xxs small">{{ status.color }}</span>
                </div>
              </td>
              <td>
                <div class="d-flex">
                  <button class="btn btn-primary-dark text-dark btn-sm rounded-3 small shadow me-2 text-xxs" data-bs-toggle="modal" data-bs-target="#update_form_status" @click="prepopulate_edit_modal(status)">Edit</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!--Create form status modal-->
<teleport to="body">
<div class="modal fade" id="create_form_status" tabindex="-1" aria-labelledby="create_form_status_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="create_form_status_label">Create Status</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3 d-flex flex-column">
          <label for="status_name" class="modal-form-label form-label text-xxs text-start">Status Name:</label>
          <input type="text" id="status_name" v-model="form_status_name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Please enter a name for the status" aria-labelledby="status_name">
          <small id="status_name_error" class="text-danger p-2 text-xxs fw-bold d-none project-name-messages">Please enter a name for the status</small>
          <small id="status_name_generic_error" class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>

        <!-- Color picker in create modal -->
        <div class="modal-form-group form-group mb-3 d-flex flex-column">
          <label for="status_color" class="modal-form-label form-label text-xxs text-start">Status Color:</label>
          <div class="d-flex align-items-center">
            <input
              type="color"
              id="status_color"
              v-model="form_status_color"
              class="form-control form-control-color p-1 me-3 w-25 h-25"
            />
            <span class="text-xxs text-muted">{{ form_status_color }}</span>
          </div>
          <small class="text-muted text-xxs mt-1">Choose a color for this status</small>
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm px-3 shadow-sm text-xxs" @click="create_form_status">Save</button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!--Edit Form status-->
<teleport to="body">
<div class="modal fade" id="update_form_status" tabindex="-1" aria-labelledby="update_form_status_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="update_form_status_label">Update Status</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3 d-flex flex-column">
          <label for="update_status_name" class="modal-form-label form-label text-start text-xxs">Status Name:</label>
          <input type="text" id="update_status_name" v-model="update_form_status_name" class="modal-form-control form-control rounded-small p-2 shadow-sm text-xxs" placeholder="Please enter a name for the status" aria-labelledby="update_status_name">
        </div>

        <!-- Color picker in edit modal -->
        <div class="modal-form-group form-group mb-3 d-flex flex-column">
          <label for="update_status_color" class="modal-form-label form-label text-xxs text-start">Status Color:</label>
          <div class="d-flex align-items-center">
            <input
              type="color"
              id="update_status_color"
              v-model="update_form_status_color"
              class="form-control form-control-color p-1 me-3 w-25 h-25"
            />
            <span class="text-xxs text-muted">{{ update_form_status_color }}</span>
          </div>
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm px-3 shadow-sm text-xxs" @click="update_form_status">Save</button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!--Assign form status to workflow-->
<teleport to="body">
<div class="modal fade" id="assign_status_to_workflow" tabindex="-1" aria-labelledby="assign_status_to_workflow_label" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content bg-white rounded-3">
      <div class="modal-header border-bottom-0 custom-header text-white">
        <h5 class="modal-title text-xxs" id="assign_status_to_workflow_label">Assign Status</h5>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body py-5">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="table-dark">
              <tr>
                <th class="text-xxs">ID</th>
                <th class="text-xxs">Workflow Name</th>
                <th class="text-xxs">Date Created</th>
                <th class="text-xxs">Assign</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="workflow in workflows" :key="workflow.ID">
                <td class="text-xxs">{{ workflow.ID }}</td>
                <td class="text-xxs">{{ workflow.status_name }}</td>
                <td class="text-xxs">{{ workflow.date_created }}</td>
                <td class="text-xxs">
                  <div class="form-check form-switch d-flex">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch">
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
</teleport>